import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { PageHeader, Loader, Badge, Empty } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { fmtDate, statusColor } from "@/lib/format";

export default function AdminSupport() {
  const { t } = useI18n();
  const [tickets, setTickets] = useState(null);
  const [sel, setSel] = useState(null);
  const [reply, setReply] = useState("");
  const load = () => api.get("/admin/support").then(({ data }) => setTickets(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!tickets) return <Loader />;

  const send = async () => {
    try {
      await api.put(`/admin/support/${sel.id}`, { reply, status: "resolved" });
      toast.success("Reply sent"); setSel(null); setReply(""); load();
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
  };

  return (
    <div>
      <PageHeader title={t("support")} subtitle="Resolve member tickets." />
      {tickets.length === 0 ? <Empty label="No tickets." /> : (
        <div className="space-y-3">
          {tickets.map((tk) => (
            <div key={tk.id} className="ec-card p-5" data-testid={`admin-ticket-${tk.id}`}>
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <div className="flex items-center gap-3"><p className="font-semibold text-white">{tk.subject}</p><Badge className={statusColor(tk.status === "open" ? "open_ticket" : "resolved")}>{tk.status}</Badge></div>
                  <p className="text-sm text-gray-400 mt-1">{tk.message}</p>
                  <p className="text-xs text-gray-500 mt-1 keep-ltr">{tk.user_name} · {tk.user_email} · {fmtDate(tk.created_at)}</p>
                  {tk.reply && <p className="text-sm text-emerald-400 mt-2">Reply: {tk.reply}</p>}
                </div>
                <Button size="sm" onClick={() => { setSel(tk); setReply(tk.reply || ""); }} data-testid={`reply-ticket-${tk.id}`} className="bg-orange-600 hover:bg-orange-500 font-semibold">{t("reply")}</Button>
              </div>
            </div>
          ))}
        </div>
      )}

      <Dialog open={!!sel} onOpenChange={(o) => !o && setSel(null)}>
        <DialogContent className="ec-card border-white/10">
          <DialogHeader><DialogTitle className="font-head">{t("reply")} — {sel?.subject}</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <p className="text-sm text-gray-400">{sel?.message}</p>
            <Textarea value={reply} onChange={(e) => setReply(e.target.value)} rows={4} data-testid="admin-reply-input" placeholder="Type your reply..." />
            <Button onClick={send} data-testid="admin-send-reply" className="w-full bg-orange-600 hover:bg-orange-500 btn-glow font-semibold">{t("send")}</Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
